import { useCallback, useEffect, useState } from 'react';
import { getOptOutIds, saveOptOut } from './optOuts';

interface IUseLotteryOptOutsParams {
  userId: number | undefined;
  isProjectLoaded: boolean;
  isServerStorageEnabled: boolean;
}

/** lotteries the player turned off in the deposit form */
export const useLotteryOptOuts = ({
  userId,
  isProjectLoaded,
  isServerStorageEnabled,
}: IUseLotteryOptOutsParams) => {
  const [optOutIds, setOptOutIds] = useState<number[]>([]);
  const [optOutsPending, setOptOutsPending] = useState(true);

  useEffect(() => {
    setOptOutIds([]);
    setOptOutsPending(true);

    if (!(userId && isProjectLoaded)) return;

    let isCancelled = false;

    getOptOutIds(userId, isServerStorageEnabled).then((ids) => {
      if (isCancelled) return;

      setOptOutIds(ids);
      setOptOutsPending(false);
    });

    return () => {
      isCancelled = true;
    };
  }, [userId, isProjectLoaded, isServerStorageEnabled]);

  const setLotteryOptOut = useCallback(
    (lotteryId: number, isOptOut: boolean) => {
      setOptOutIds((ids) => {
        const rest = ids.filter((id) => id !== lotteryId);

        return isOptOut ? [...rest, lotteryId] : rest;
      });

      if (userId) {
        void saveOptOut(userId, isServerStorageEnabled, lotteryId, isOptOut);
      }
    },
    [userId, isServerStorageEnabled]
  );

  return { optOutIds, optOutsPending, setLotteryOptOut };
};
